/*
 * 대시보드에서 고를 수 있는 국가를 취급 국가로 제한한다 (2026-09-08 KST 추가)
 *
 * Saleor 는 shop.countries 로 전세계 국가를 내려주는데, 쓰지 않는 항목이 대부분이라
 * 배송지역·채널·세금 등의 국가 선택에서 고르기가 어려웠다.
 * 목록을 늘리거나 줄이려면 아래 배열만 고치면 된다.
 */
export const ALLOWED_COUNTRY_CODES = ["KR", "US", "CN", "JP"];

export const onlyAllowedCountries = <T extends { code: string }>(countries: T[]): T[] =>
  countries.filter(({ code }) => ALLOWED_COUNTRY_CODES.includes(code));
